/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minagefeature2Inputs */

const en_minagefeature2 = /** @type {(inputs: Minagefeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum age`)
};

const de_minagefeature2 = /** @type {(inputs: Minagefeature2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mindestalter`)
};

/**
* | output |
* | --- |
* | "Minimum age" |
*
* @param {Minagefeature2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const minagefeature2 = /** @type {((inputs?: Minagefeature2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minagefeature2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minagefeature2(inputs)
	return de_minagefeature2(inputs)
});
export { minagefeature2 as "minAgeFeature" }